<template lang="html">
  <div v-if="isActive" class="tab">
    <slot />
  </div>
</template>

<script>
import { EventBus } from '@/plugins/event-bus'

export default {
  props: {
    title: {
      type: String,
      default: 'Tab',
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isActive: true,
    }
  },
  created() {
    EventBus.$on('select-tab', this.selectTab)
  },
  unmounted() {
    EventBus.$off('select-tab', this.selectTab)
  },
  methods: {
    selectTab(index) {
      this.isActive = index == this.index
    },
  },
}
</script>

<style lang="scss" scoped>
.tab {
  padding: 30px;
}
</style>
